module.exports = __webpack_public_path__ + "img/bg_02.3a59c902.jpg";